import React from 'react';
import {FormattedMessage} from 'react-intl';
import {FileItem} from '../FileItem/FileItem';
import Empty from '../../../../../_common/components/Empty';
import Unit from '../../../../../_common/components/Unit';
import styles from './styles.module.scss';

export function FileList({
                           gotFiles,
                           fileList,
                           orderID,
                           shumaID,
                           showFileTypeColumn = true,
                           allowDownloadFile = true,
                           allowDeleteFile = true,
                           allowSelectFile = false,
                           fileTypeID,
                           closePopup
                         }) {
  const mapFiles = file => {
    const {
      fileID,
      fileName,
      fileTypeName,
      fileExtension
    } = file;

    return (
      <FileItem
        fileName={fileName}
        fileID={fileID}
        fileTypeName={fileTypeName}
        fileTypeID={fileTypeID}
        fileExtension={fileExtension}
        orderID={orderID}
        shumaID={shumaID}
        showFileTypeColumn={showFileTypeColumn}
        allowDownloadFile={allowDownloadFile}
        allowDeleteFile={allowDeleteFile}
        allowSelectFile={allowSelectFile}
        closePopup={closePopup}
      />
    );
  };
  const prefix = 'inspection-details-page-files';

  return (
    <div>
      {gotFiles
        ? (
          <Unit
            text={['הזמנת קבצים' ,orderID].filter(Boolean).join(' ')}
            icon={'/media/common/List_primary.svg'}
          >
            <div className={styles.header}>
              <div className={styles.headerCell}>
                <FormattedMessage id={`${prefix}-column-name`} defaultMessage="Name"/>
              </div>
              {showFileTypeColumn && (
                <div className={styles.headerCell}>
                  <FormattedMessage id={`${prefix}-column-type`} defaultMessage="Type"/>
                </div>
              )}
              {allowDeleteFile && (
                <div className={styles.headerCell}>
                  <FormattedMessage id={`${prefix}-column-deleteFile`} defaultMessage="Delete"/>
                </div>
              )}
              {allowDownloadFile && (
                <div className={styles.headerCell}>
                  <FormattedMessage id={`${prefix}-column-downloadFile`} defaultMessage="Download"/>
                </div>
              )}
              {allowSelectFile && (
                <div className={styles.headerCell}>
                  <FormattedMessage id={`${prefix}-column-selectFile`} defaultMessage="Select"/>
                </div>
              )}
            </div>
            <div className={styles.list}>
              {fileList.map(mapFiles)}
            </div>
          </Unit>
        )
        : (
          <Empty
            customContainerClassname={'pt-12'}
            message={(
              <FormattedMessage
                id="no-files-old-inspection-details-copy-from-order"
                defaultMessage="This order has no associated files."
              />
            )}
          />
        )
      }
    </div>
  );
}
